// extracted by mini-css-extract-plugin
export default {"FlexForm":"AvTzYt3KwqL52CnhTYOt"};